import { ChangeDetectorRef, Component } from '@angular/core';
import { StockCardsComponent } from '../../../partials/stock-cards/stock-cards.component';
import { Subscription } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Router } from '@angular/router';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';

@Component({
  selector: 'structured-product-card',
  templateUrl: './structured-product-card.component.html',
  styleUrls: ['./structured-product-card.component.scss']
})
export class StructuredProductCardComponent extends StockCardsComponent {
  public tooltips: { [prop: string]: string } = {};
  public currentInvestedValue: number = 0;
  public symbol: string;
  public symbolLogo: string;
  public symbolName: string;
  public sideText: string = 'ESTRUTURADA';
  public instrument = null;
  private instrumentSubscription: Subscription;

  public advisor = this.store
    .select(state => state.advisor.customerAdvisor)
    .pipe(
      map(item => {
        let url: URL;
        if (!item) {
          url = new URL('https://api.whatsapp.com/send?phone=551140001580');
        } else {
          url = new URL(item.whatsapp.link);
        }

        url.searchParams.set(
          'text',
          'Olá! Quero mais informações sobre Barreira Atingida.'
        );
        return url;
      })
    );

  constructor(
    protected store: Store<AppState>,
    protected changeDetectorRef: ChangeDetectorRef,
    protected router: Router,
    protected dialogServices: DialogsService
  ) {
    super(router, dialogServices, store, changeDetectorRef);
  }

  public ngOnInit() {
    this.startTips();
    this.currentInvestedValue = this.stockDetails.ordersAmountInvested;
    this.symbol = this.stockDetails.symbol;
    this.bindInstrumentSubscription();

    if (this.symbol) {
      this.store.dispatch({
        type: StocksMarketAction.getInstrumentInfo,
        payload: this.symbol
      });
    }
  }

  public bindInstrumentSubscription = () => {
    this.instrumentSubscription = this.store
      .select(state => state.stocksExchange.stocksMarket.instruments)
      .pipe(
        filter(item => this.stockDetails && !!item[this.symbol]),
        map(item => item[this.symbol]),
        first()
      )
      .subscribe(instrument => {
        this.instrument = instrument;
        this.symbolLogo = this.instrument.logo.content;
        this.symbolName = this.instrument.descriptionStock;
      });
  };

  public getBarrierReachedCardText() {
    let knock = '';
    if (this.stockDetails.barrierReached === 'KI') {
      knock = 'in';
    } else if (this.stockDetails.barrierReached === 'KO') {
      knock = 'out';
    }
    return `<strong>Barreira atingida - Knock-${knock}</strong><br/><br/>Devido à oscilação do ativo, a barreira da sua operação foi atingida. Entre em contato com a Assessoria para mais informações.`;
  }

  public startTips() {
    this.tooltips.estimatedValue = `
        <div>
            <div class='pop-content'>
                <h2>Valor estimado</h2>
                <p>
                    Enquanto a operação estiver ativa, o valor estimado continua oscilando, porém o valor considerado para recebimento é calculado a depender do atingimento ou não da barreira.
                </p>
            </div>
        </div>
    `;
  }
}
